export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f90eb7bf99658e7354496bd55f33e26fcc4b27af0&name=fetchTypeahead!'